<template>
  <div class="row">
    <!-- heading & button -->
    <card>
      <template>
        <div class="col-lg-12 col-md-6">
          <!-- <card type="chart"> -->
          <!-- <template slot="header"> -->
          <div class="row">
            <div class="col-lg-4">
              <h3 class="card-title brightness">
                <div class="text-center text-md-left">
                  <base-button
                    type="success"
                    @click.native="modals.notice = true"
                    >Add Device</base-button
                  >&nbsp;
                  <base-button
                    type="success"
                    @click.native="modals.upload = true"
                    >Import CSV</base-button
                  >
                </div>
                <!-- <span>{{moment(date).format('YYYY-MM-DD')}}</span> -->
                <!-- Add device modal -->
                <modal
                  :show.sync="modals.notice2"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">Add Device Form</h3>
                  <base-button
                    class="mt-3 btn-link"
                    @click="closeModal2()"
                    @click.native="modals.notice = true"
                  >
                    <i class="tim-icons icon-minimal-left"></i>Previous
                  </base-button>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div>
                            <base-input
                              v-model="device.brand"
                              label="Device Brand / Manufacturer"
                              placeholder="Device Brand / Manufacturer"
                            ></base-input>
                            <base-input
                              v-model="device.modelNum"
                              label="Model Number"
                              placeholder="Model Number"
                            ></base-input>
                            <base-input
                              label="Commission Date"
                              placeholder="Commission Date"
                            >
                              <el-date-picker
                                type="date"
                                placeholder="Date Picker"
                                v-model="device.commdate"
                              ></el-date-picker>
                            </base-input>
                            <base-input
                              label="Warranty Date"
                              placeholder="Warranty Date"
                            >
                              <el-date-picker
                                type="date"
                                placeholder="Date Picker"
                                v-model="device.warrantyDate"
                              ></el-date-picker>
                            </base-input>
                            <base-input
                              v-model="device.latitude"
                              label="Latitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              v-model="device.longitude"
                              label="Longitude"
                              placeholder="Longitude"
                            ></base-input>
                            <base-input
                              v-model="device.timezone"
                              label="Time Zone"
                              placeholder="Time Zone"
                            >
                              <el-select
                                class="select-primary mb-3 pagination-select"
                                v-model="select.timez"
                                placeholder="Choose..."
                              >
                                <el-option
                                  v-for="select in select.timezone"
                                  class="select-primary"
                                  :value="select.value"
                                  :label="select.label"
                                  :key="select.label"
                                ></el-option>
                              </el-select>
                            </base-input>
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click.native="addDevice(device.conntype)"
                              >Add</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.notice2 = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>
                <modal
                  :show.sync="modals.notice"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">Add Device Form</h3>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-md-12">
                        <form @submit.prevent>
                          <div>
                            <base-input
                              label="Connection Type"
                              placeholder="Connection Type"
                            >
                              <el-select
                                v-model="device.conntype"
                                class="select-success"
                                size="large"
                                placeholder="Connection Type"
                              >
                                <el-option
                                  v-for="option in device.conntypes"
                                  class="select-success"
                                  :value="option.value"
                                  :label="option.label"
                                  :key="option.label"
                                ></el-option>
                              </el-select>
                            </base-input>

                            <div v-if="device.conntype === 'lora'">
                              <base-input
                                label="Device Type"
                                placeholder="Device Type"
                              >
                                <el-select
                                  v-model="device.devicetype"
                                  class="select-success"
                                  size="large"
                                  placeholder="Device Type"
                                >
                                  <el-option
                                    v-for="option in device.devicetypes"
                                    class="select-success"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.label"
                                  ></el-option>
                                </el-select>
                              </base-input>
                              <base-input
                                v-model="device.devicename"
                                label="Device Name"
                                placeholder="Device Name"
                              ></base-input>
                              <base-input
                                v-model="device.devicetoken"
                                label="Device Token"
                                placeholder="Device Token"
                              ></base-input>
                              <base-input
                                v-model="device.loraAppKey"
                                label="Lora app key"
                                placeholder="Lora app key"
                              ></base-input>
                            </div>
                            <div v-else-if="device.conntype === 'nbiot'">
                              <base-input
                                label="Device Type"
                                placeholder="Device Type"
                              >
                                <el-select
                                  v-model="device.devicetype"
                                  class="select-success"
                                  size="large"
                                  placeholder="Device Type"
                                >
                                  <el-option
                                    v-for="option in device.devicetypes"
                                    class="select-success"
                                    :value="option.value"
                                    :label="option.label"
                                    :key="option.label"
                                  ></el-option>
                                </el-select>
                              </base-input>
                              <base-input
                                v-model="device.devicetoken"
                                label="Device Token"
                                placeholder="Device Token"
                              ></base-input>

                              <base-input
                                v-model="device.devicename"
                                label="Device Name"
                                placeholder="Device Name"
                              ></base-input>
                            </div>

                            <!-- <base-input
                              v-model="device.brand"
                              label="Device Brand / Manufacturer"
                              placeholder="Device Brand / Manufacturer"
                            ></base-input>
                            <base-input
                              v-model="device.brand"
                              label="Model Number"
                              placeholder="Model Number"
                            ></base-input>
                            <base-input
                              v-model="device.commDate"
                              label="Commission Date"
                              placeholder="Commission Date"
                            >
                              <el-date-picker
                                type="date"
                                placeholder="Date Picker"
                                v-model="datePicker"
                              ></el-date-picker>
                            </base-input>
                            <base-input
                              v-model="device.warrantyDate"
                              label="Warranty Date"
                              placeholder="Warranty Date"
                            >
                              <el-date-picker
                                type="date"
                                placeholder="Date Picker"
                                v-model="datePicker"
                              ></el-date-picker>
                            </base-input>
                            <base-input
                              v-model="device.latitude"
                              label="Latitude"
                              placeholder="Latitude"
                            ></base-input>
                            <base-input
                              v-model="device.longitude"
                              label="Longitude"
                              placeholder="Longitude"
                            ></base-input>
                            <base-input
                              v-model="device.timezone"
                              label="Time Zone"
                              placeholder="Time Zone"
                            >
                              <el-select
                                class="select-primary mb-3 pagination-select"
                                v-model="select.timez"
                                placeholder="Choose..."
                              >
                                <el-option
                                  v-for="select in select.timezone"
                                  class="select-primary"
                                  :value="select.value"
                                  :label="select.label"
                                  :key="select.label"
                                ></el-option>
                              </el-select>
                            </base-input>-->
                            <!-- <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click.native="addDevice()"
                            >Add</base-button>-->
                            <base-button
                              class="mt-3"
                              native-type="submit"
                              type="success"
                              @click.native="modals.notice2 = true"
                              @click="closeModal()"
                              >Continue....</base-button
                            >
                            <base-button
                              class="mt-3"
                              type="danger"
                              @click.native="modals.notice = false"
                              >Cancel</base-button
                            >
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </modal>

                <!-- upload csv modal -->
                <modal
                  :show.sync="modals.upload"
                  footer-classes="justify-content-center"
                  type="notice"
                >
                  <h3 slot="header" class="modal-title">Import CSV Form</h3>
                  <div class="modal-body">
                    <div class="row">
                      <div
                        class="col-md-6"
                        style="border-right: solid black 1px"
                      >
                        <base-input
                          label="Connection Type"
                          placeholder="Connection Type"
                        >
                          <el-select
                            v-model="deviceCSV"
                            class="select-success"
                            size="large"
                            placeholder="Connection Type"
                          >
                            <el-option
                              v-for="option in device.conntypes"
                              class="select-success"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <div class="col-md-6 text-center">
                        <label id="fileName">{{ fileName }}</label>
                        <span class="btn btn-info btn-file">
                          <span class="fileinput-new">Choose File</span>
                          <input
                            accept=".csv"
                            type="file"
                            class="valid"
                            :multiple="false"
                            aria-invalid="false"
                            @change="readFile"
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <template slot="footer">
                    <base-button
                      @click="addDeviceCSV"
                      class="mt-3"
                      native-type="submit"
                      type="success"
                      >Submit</base-button
                    >&nbsp;&nbsp;&nbsp;
                    <base-button
                      class="mt-3"
                      type="danger"
                      @click.native="modals.upload = false"
                      >Cancel</base-button
                    >
                  </template>
                </modal>

                <div slot="footer"></div>
              </h3>
            </div>
          </div>
          <!-- </template> -->
          <!-- </card> -->
        </div>

        <!-- Devices -->
        <div class="col-lg-12 col-md">
          <!-- tables -->
          <div>
            <!-- pagination -->
            <div
              class="
                col-12
                d-flex
                justify-content-center justify-content-sm-between
                flex-wrap
              "
            >
              <el-select
                class="select-primary mb-3 pagination-select d-none d-sm-block"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <base-input type="success">
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search records"
                  v-model="searchQuery"
                  aria-controls="datatables"
                ></el-input>
              </base-input>
            </div>
            <!-- table data -->
            <el-table
              :data="
                queriedData.filter(
                  (data) =>
                    !searchQuery ||
                    data.devicename
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase())
                )
              "
              :header-cell-style="{
                background: 'transparent',
                border: 'transparent',
                'padding-bottom': '0%',
                'padding-center': '10px',
                color: 'white',
              }"
              :cell-style="{
                border: 'transparent',
                'padding-center': '20px',
              }"
            >
              <el-table-column
                min-width="150"
                sortable
                label="Device Name"
                property="devicename"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                label="Device Type"
                property="devicetype"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                label="Connection Type"
                property="connection_type"
              ></el-table-column>
              <el-table-column
                min-width="190"
                sortable
                label="Device Description"
                property="devicedesc"
              ></el-table-column>
              <!-- <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Device Attribute"
                property="deviceattr"
              ></el-table-column>-->
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Created At"
                property="createdAt"
              ></el-table-column>
              <el-table-column
                min-width="150"
                sortable
                align="right"
                header-align="right"
                label="Updated At"
                property="updatedAt"
              ></el-table-column>
              <el-table-column :min-width="100" align="right" label="Actions">
                <div slot-scope="props">
                  <el-tooltip content="Edit" placement="bottom" effect="light">
                    <base-button
                      @click.native="modals.edit = true"
                      @click="getRow(props.row)"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <!-- modal to edit device details -->
          <modal
            :show.sync="modals.edit"
            footer-classes="justify-content-center"
            type="notice"
          >
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent>
                    <div class="row justify-content-center mt-12">
                      <div class="col-sm-12">
                        <div>
                          <h3 style="color: #344675">Device Information</h3>
                          <base-input
                            v-model="device.devicename"
                            type="text"
                            label="Device Name"
                            placeholder="Device Name"
                          ></base-input>
                          <base-input
                            label="Connection Type"
                            placeholder="Connection Type"
                            v-model="device.conntype"
                            type="text"
                            disabled
                          ></base-input>
                          <base-input
                            label="Device Type"
                            placeholder="Device Type"
                            v-model="device.devicetype"
                            type="text"
                            disabled
                          ></base-input>
                          <base-input
                            v-model="device.lat"
                            type="text"
                            label="Latitude"
                            placeholder="Latitude"
                          ></base-input>
                          <base-input
                            v-model="device.lon"
                            type="text"
                            label="Longitude"
                            placeholder="Longitude"
                          ></base-input>
                          <base-input label="Commission Date">
                            <el-date-picker
                              v-model="device.commdate"
                              type="date"
                              label="Commission Date"
                              placeholder="Commission Date"
                            ></el-date-picker>
                          </base-input>
                          <base-input label="Warranty">
                            <el-date-picker
                              v-model="device.warranty"
                              type="date"
                              label="Warranty"
                              placeholder="Warranty"
                            ></el-date-picker>
                          </base-input>
                        </div>
                      </div>
                      <div>
                        <base-button
                          class="mt-3"
                          native-type="submit"
                          type="success"
                          @click.native="handleEdit()"
                          >Submit</base-button
                        >
                        <base-button
                          class="mt-3"
                          type="danger"
                          @click.native="modals.edit = false"
                          >Cancel</base-button
                        >
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </modal>

          <!-- <h5 class="card-category">Devices</h5>
          <h3 class="card-title brightness">
            <div>
              <div
                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  class="select-primary mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>

                <base-input>
                  <el-input
                    type="search"
                    class="mb-3 search-input"
                    clearable
                    prefix-icon="el-icon-search"
                    placeholder="Search records"
                    v-model="searchQuery"
                    aria-controls="datatables"
                  ></el-input>
                </base-input>
              </div>
              <el-table :data="queriedData">
                <el-table-column
                  v-for="column in tableColumns"
                  :key="column.label"
                  :min-width="column.minWidth"
                  :prop="column.prop"
                  :label="column.label"
                ></el-table-column>
                <el-table-column :min-width="135" align="right" label="Actions">
                  <div slot-scope="props">
                    <base-button
                      @click.native="modals.edit = true"
                      class="edit btn-link"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>

                    <modal
                      :show.sync="modals.edit"
                      footer-classes="justify-content-center"
                      type="notice"
                    >
                      <div class="modal-body">
                        <div class="row">
                          <div class="col-md-12">
                            <form @submit.prevent>
                              <div class="row justify-content-center mt-12">
                                <div class="col-sm-6">
                                  <div>
                                    <h3 style="color: #344675;">Device Information</h3>
                                    <base-input
                                      v-model="device.deviceNo"
                                      label="Device No"
                                      placeholder="Device No"
                                    ></base-input>
                                    <base-input
                                      v-model="device.name"
                                      label="Device Name"
                                      placeholder="Device Name"
                                    ></base-input>
                                    <base-input
                                      v-model="device.type"
                                      label="Device Type"
                                      placeholder="Device Type"
                                    ></base-input>
                                    <base-input
                                      v-model="device.brand"
                                      label="Device Brand / Manufacturer"
                                      placeholder="Device Brand / Manufacturer"
                                    ></base-input>
                                    <base-input
                                      v-model="device.modelno"
                                      label="Model Number"
                                      placeholder="Model Number"
                                    ></base-input>
                                    <base-input
                                      v-model="device.commDate"
                                      label="Commission Date"
                                      placeholder="Commission Date"
                                    >
                                      <el-date-picker
                                        type="date"
                                        placeholder="Date Picker"
                                        v-model="datePicker"
                                      ></el-date-picker>
                                    </base-input>
                                    <base-input
                                      v-model="device.warrantyDate"
                                      label="Warranty Date"
                                      placeholder="Warranty Date"
                                    >
                                      <el-date-picker
                                        type="date"
                                        placeholder="Date Picker"
                                        v-model="datePicker"
                                      ></el-date-picker>
                                    </base-input>
                                    <base-input
                                      v-model="device.latitude"
                                      label="Latitude"
                                      placeholder="Latitude"
                                    ></base-input>
                                    <base-input
                                      v-model="device.longitude"
                                      label="Longitude"
                                      placeholder="Longitude"
                                    ></base-input>
                                    <base-input
                                      v-model="device.timezone"
                                      label="Time Zone"
                                      placeholder="Time Zone"
                                    ></base-input>
                                  </div>
                                </div>

                                <div class="col-sm-6">
                                  <div>
                                    <h3 style="color: #344675;">Cluster Information</h3>
                                    <base-input label="Cluster ID" placeholder="Cluster ID">
                                      <el-select
                                        class="select-success"
                                        size="large"
                                        placeholder="Single Select"
                                        v-model="device.clusterID"
                                      >
                                        <el-option
                                          v-for="option in device.clusterID"
                                          class="select-success"
                                          :value="option.value"
                                          :label="option.label"
                                          :key="option.label"
                                        ></el-option>
                                      </el-select>
                                    </base-input>
                                  </div>
                                </div>
                                <div>
                                  <base-button
                                    class="mt-3"
                                    native-type="submit"
                                    type="success"
                                  >Submit</base-button>
                                  <base-button
                                    class="mt-3"
                                    type="danger"
                                    @click.native="modals.edit = false"
                                  >Cancel</base-button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </modal>

                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
          </div>-->
          <div
            slot="footer"
            class="
              col-12
              d-flex
              justify-content-center justify-content-sm-between
              flex-wrap
            "
          >
            <div class>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
          <!-- </h3>-->
        </div>
      </template>
    </card>
  </div>
</template>
<script>
import swal from "sweetalert2";
import { Modal, BasePagination } from "src/components";
import { Slider, BaseSwitch } from "src/components/index";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import users from "./users"; //read users from this file
import Fuse from "fuse.js";

var moment = require("moment"); // Change date format

export default {
  components: {
    [DatePicker.name]: DatePicker,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
  },
  data() {
    return {
      fileName: "No File Selected",
      select: {
        timezone: [
          {
            label: "(GMT+08:00) Kuala Lumpur, Singapore",
            value: "Asia/Kuala_Lumpur",
          },
          { label: "(GMT-12:00) International Date Line West", value: -12 },
          { label: "(GMT-11:00) Midway Island, Samoa", value: -11 },
          { label: "(GMT-10:00) Hawaii", value: -10 },
          { label: "(GMT-09:00) Alaska", value: -9 },
          { label: "(GMT-08:00) Pacific Time (US & Canada)", value: -8 },
          {
            label: "(GMT-08:00) Tijuana, Baja California",
            value: "America/Tijuana",
          },
          { label: "(GMT-07:00) Arizona", value: "US/Arizona" },
          {
            label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
            value: "America/Chihuahua",
          },
          {
            label: "(GMT-07:00) Mountain Time (US & Canada)",
            value: "US/Mountain",
          },
          { label: "(GMT-06:00) Central America", value: "America/Managua" },
          {
            label: "(GMT-06:00) Central Time (US & Canada)",
            value: "US/Central",
          },
          {
            label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
            value: "America/Mexico_City",
          },
          { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
          {
            label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
            value: "America/Bogota",
          },
          {
            label: "(GMT-05:00) Eastern Time (US & Canada)",
            value: "US/Eastern",
          },
          { label: "(GMT-05:00) Indiana (East)", value: "US/East-Indiana" },
          {
            label: "(GMT-04:00) Atlantic Time (Canada)",
            value: "Canada/Atlantic",
          },
          { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
          { label: "(GMT-04:00) Manaus", value: "America/Manaus" },
          { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
          { label: "(GMT-03:30) Newfoundland", value: "Canada/Newfoundland" },
          { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
          {
            label: "(GMT-03:00) Buenos Aires, Georgetown",
            value: "America/Argentina/Buenos_Aires",
          },
          { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
          { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
          { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
          { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
          { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
          {
            label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
            value: "Africa/Casablanca",
          },
          {
            label:
              "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
            value: "Etc/Greenwich",
          },
          {
            label:
              "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
            value: "Europe/Amsterdam",
          },
          {
            label:
              "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
            value: "Europe/Belgrade",
          },
          {
            label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
            value: "Europe/Brussels",
          },
          {
            label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
            value: "Europe/Sarajevo",
          },
          { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
          { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
          {
            label: "(GMT+02:00) Athens, Bucharest, Istanbul",
            value: "Europe/Athens",
          },
          { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
          { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
          { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
          {
            label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
            value: "Europe/Helsinki",
          },
          { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
          { label: "(GMT+02:00) Minsk", value: "Europe/Minsk" },
          { label: "(GMT+02:00) Windhoek", value: "Africa/Windhoek" },
          {
            label: "(GMT+03:00) Kuwait, Riyadh, Baghdad",
            value: "Asia/Kuwait",
          },
          {
            label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
            value: "Europe/Moscow",
          },
          { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
          { label: "(GMT+03:00) Tbilisi", value: "Asia/Tbilisi" },
          { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
          { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
          { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
          { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
          { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
          { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
          {
            label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
            value: "Asia/Karachi",
          },
          {
            label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
            value: "Asia/Calcutta",
          },
          { label: "(GMT+05:30) Sri Jayawardenapura", value: "Asia/Calcutta" },
          { label: "(GMT+05:45) Kathmandu", value: "Asia/Katmandu" },
          { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
          { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
          { label: "(GMT+06:30) Yangon (Rangoon)", value: "Asia/Rangoon" },
          {
            label: "(GMT+07:00) Bangkok, Hanoi, Jakarta",
            value: "Asia/Bangkok",
          },
          { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
          {
            label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
            value: "Asia/Hong_Kong",
          },
          { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
          { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
          { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
          { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
          { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
          { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
          { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
          { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
          { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
          {
            label: "(GMT+10:00) Canberra, Melbourne, Sydney",
            value: "Australia/Canberra",
          },
          { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
          { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
          { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
          {
            label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
            value: "Asia/Magadan",
          },
          {
            label: "(GMT+12:00) Auckland, Wellington",
            value: "Pacific/Auckland",
          },
          {
            label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
            value: "Pacific/Fiji",
          },
          { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
        ],

        timez: "",
      },
      deviceCSV: "",
      devices: [],
      device: {
        devicetypes: [
          { value: "nodestl", label: "StreetLight NEMA Node" },
          { value: "lux", label: "Lux Sensor" },
        ],
        conntypes: [
          { value: "nbiot", label: "NB-IoT" },
          { value: "lora", label: "LoraWAN" },
        ],
        deviceid: "",
        devicename: "",
        devicetype: "",
        conntype: "",
        devicetoken: "",
        loraAppKey: "",
        devicedesc: "",
        deviceattr: "",
        CreatedAt: "",
        UpdatedAt: "",
        lat: "",
        lon: "",
        commdate: "",
        warranty: "",
        // deviceNo: "",
        // name: "",
        // type: "",
        // brand: "",
        // commDate: "",
        // warrantyDate: "",
        // latitude: "",
        // longitude: "",
        // clusterID: ["cluster 1", "cluster 2"],
        // firmware: "",
        // qr: require("@/assets/img/qr.png")
      },
      selects: {
        simple: "",
      },
      datePicker: "",
      modals: {
        notice2: false,
        notice: false,
        upload: false,
        edit: false,
      },
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["devicename", "devicetype"],
      tableData: users,
      searchedData: [],
      fuseSearch: null,
      getRowData: "",
      payloadCSV: [],
    };
  },
  created() {
    console.log(moment().add(5, "Y").format("DD-MM-YYYY"));
    this.device.commdate = moment().add(5, "Y").format("YYYY-MM-DD");
    this.device.warrantyDate = moment().add(5, "Y").format("YYYY-MM-DD");
  },
  methods: {
    readFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (e) => {
        const loraAttribute = ["device name", "device token", "device appKey"];
        const nbiotAttribute = ["device name", "device token"];

        let header;
        let lines = [];
        let csv = e.target.result; // Content from file
        console.log(csv);
        let allTextLines = csv.split(/\r\n|\n/);
        console.log("DSDSDS",allTextLines )
        for (let i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        lines.pop();
        console.log(lines);

        lines.forEach((line) => {
          if (line.length === 3) {
            // Lora
            for (let i = 0; i < 1; i++) {
              this.payloadCSV.push({
                devicename: line[0],
                devicedesc: "device",
                devicetype: "nodestl",
                devicetoken: line[1],
                appkey: line[2],
              });
            }
          } else if (line.length === 2) {
            for (let i = 0; i < 1; i++) {
              this.payloadCSV.push({
                devicename: line[0],
                devicedesc: "device",
                devicetype: "nodestl",
                devicetoken: line[1],
              });
            }
          } else {
            swal({
              type: "error",
              title: "Column Error!",
              text: "Please redo your CSV file!",
            });
            this.fileName = "CSV Error";
          }
        });
        console.log(this.payloadCSV);
      };
      this.fileName = file.name;
    },
    addDeviceCSV() {
      let payload;

      if (this.fileName == "No File Selected" || !this.deviceCSV) {
        if (this.fileName == "No File Selected") {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: "Please select a CSV file!",
          });
        }
        if (!this.deviceCSV) {
          swal({
            type: "error",
            title: "Oops... Something went wrong!",
            text: "Please select a Device Type!",
          });
        }
      } else {
        console.log(this.deviceCSV);

        if (this.deviceCSV === "lora") {
          // lora
          payload = {
            connection_type: this.deviceCSV,
            devicelist: this.payloadCSV,
          };
          console.log(payload);

          this.$http
            .post(":8002/api/v1/manage/device", payload)
            .then((res) => {
              console.log(res);
              if (res.error) {
                swal({
                  type: "error",
                  title: "Oops... Something went wrong!",
                  text: res.message,
                });
              } else {
                swal({
                  type: "success",
                  title: "Well done !!",
                  text: res.message,
                });
                this.getDeviceList();
                this.modals.upload = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else if (this.deviceCSV === "nbiot") {
          console.log("Masuk nbiot");

          // nbiot
          payload = {
            connection_type: this.deviceCSV,
            devicelist: this.payloadCSV,
          };
          console.log(payload);

          this.$http
            .post(":8002/api/v1/manage/device", payload)
            .then((res) => {
              if (res.error) {
                swal({
                  type: "error",
                  title: "Oops... Something went wrong!",
                  text: res.message,
                });
                console.log(res.message);
              } else {
                swal({
                  type: "success",
                  title: "Well done !!",
                  text: res.message,
                });
                this.getDeviceList();
                this.modals.upload = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    closeModal() {
      this.modals.notice = false;
    },
    closeModal2() {
      this.modals.notice2 = false;
    },
    getDeviceList() {
      const arr = [];
      this.devices = []
      this.searchedData = []
      this.$http
        .get(":8002/api/v1/manage/device")
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
            console.log(res.message);
          } else {
            console.log(this.devices)
            console.log("RAW: ", res.message.device_list);
            let data = JSON.parse(JSON.stringify(res.message.device_list));
            console.log(data);
            arr.push(data);
            console.log(arr);
            this.devices = data;
            this.searchedData = data
            console.log(this.devices);
            for (let i = 0; i < this.devices.length; i++) {
              // console.log(this.devices[i].createdAt);
              this.devices[i].createdAt = moment(this.devices[i].createdAt)
                .format("LLL")
                .toString();
              this.devices[i].updatedAt = moment(this.devices[i].updatedAt)
                .format("LLL")
                .toString();
              this.devices[i].connection_type == "lora"
                ? (this.devices[i].connection_type = "LoraWAN")
                : (this.devices[i].connection_type = "NB-IoT");
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addDevice(connType) {
      console.log(connType);
      // error handling / verification
      if (this.device.devicename === "") {
        swal({
          type: "error",
          title: "Device name cannot be empty!",
        });
      } else {
        if (this.device.devicetoken === "") {
          swal({
            type: "error",
            title: "Device Token cannot be empty!",
          });
        } else {
          var payload = null;
          if (connType === "lora") {
            // lora
            console.log(this.device.loraAppKey);
            if (this.device.loraAppKey === "") {
              swal({
                type: "error",
                title: "Lora App Key cannot be empty!",
              });
            } else {
              payload = {
                connection_type: this.device.conntype,
                devicelist: [
                  {
                    devicename: this.device.devicename,
                    devicedesc: "device",
                    devicetype: this.device.devicetype,
                    devicetoken: this.device.devicetoken,
                    appkey: this.device.loraAppKey,
                    commdate: moment(this.device.commDate).format("YYYY-MM-DD"),
                    warranty: moment(this.device.warrantyDate).format(
                      "YYYY-MM-DD"
                    ),
                  },
                ],
              };
              console.log(payload);
            }
          } else if (connType === "nbiot") {
            // nbiot
            payload = {
              connection_type: this.device.conntype,
              devicelist: [
                {
                  devicename: this.device.devicename,
                  devicedesc: "device",
                  devicetype: this.device.devicetype,
                  devicetoken: this.device.devicetoken,
                  commdate: moment(this.device.commDate).format("YYYY-MM-DD"),
                  warranty: moment(this.device.warrantyDate).format(
                    "YYYY-MM-DD"
                  ),
                },
              ],
            };
          } else {
            console.log("Unkwin ");
          }

          console.log(payload);

          // api
          this.$http
            .post(":8002/api/v1/manage/device", payload)
            .then((res) => {
              if (res.error) {
                swal({
                  type: "error",
                  title: "Oops... Something went wrong!",
                  text: res.message,
                });
                //pupout oeror
                console.log(res.message);
              } else {
                swal({
                  type: "success",
                  title: "Well done !!",
                  text: res.message,
                });

                console.log(res);
                this.getDeviceList();
                this.device.devicetype = "";
                this.device.devicetoken = "";
                this.device.loraAppKey = "";
                this.device.devicename = "";
                this.device.brand = "";
                this.device.modelNum = "";
                this.device.commDate = "";
                this.device.warrantyDate = "";
                this.device.latitude = "";
                this.device.longitude = "";
                this.modals.notice2 = false;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    handleEdit(index, row) {
      swal({
        title: "Are you sure?",
        text: `You want to edit ${this.getRowData.devicename}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, edit it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.editDevice();
          swal({
            title: "Edited!",
            text: `You edited ${this.getRowData.devicename}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    editDevice() {
      // "devicename":"STRING",
      // "devicedesc":"STRING",
      // "commdate":"STRING",
      // "lat":"STRING",
      // "lon":"STRING",
      // "warranty":"STRING",
      console.log(moment(this.device.commdate).format("YYYY-MM-DD"));
      console.log(moment(this.device.warranty).format("YYYY-MM-DD"));

      let commdate = moment(this.device.commdate).format("YYYY-MM-DD");
      let warranty = moment(this.device.warranty).format("YYYY-MM-DD");

      let payload = {
        devicename: this.device.devicename,
        devicedesc: "device",
        commdate: commdate,
        lat: parseFloat(this.device.lat),
        lon: parseFloat(this.device.lon),
        warranty: warranty,
      };
      console.log(payload);

      console.log(this.device.deviceid);
      console.log(this.queriedData);

      this.$http
        .put(":8002/api/v1/manage/device/" + this.device.deviceid, payload)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            //pupout oeror
            console.log(res.message);
          } else {
            swal({
              type: "success",
              title: "Well done !!",
              text: res.message,
            });
            //login OK!
            console.log(res);
            this.getDeviceList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.modals.edit = false;
    },
    handleDelete(index, row) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.deleteRow(row);
          swal({
            title: "Deleted!",
            text: `You deleted ${row.devicename}`,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
    deleteRow(row) {
      console.log(row);
      console.log("sd", row.deviceid);

      this.$http
        .delete(":8002/api/v1/manage/device/" + row.deviceid)
        .then((res) => {
          if (res.error) {
            swal({
              type: "error",
              title: "Oops... Something went wrong!",
              text: res.message,
            });
            this.message = res.message;
          } else {
            //login OK!
            console.log(res);
            // function compare id to remove user from queriedData array
            // this.devices = []
            
            // this.pagination.currentPage = 1
            this.getDeviceList();
            console.log(this.queriedData);
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // let indexToDelete = this.devices.findIndex(
      //   tableRow => tableRow.id === row.id
      // );
      // if (indexToDelete >= 0) {
      //   this.devices.splice(indexToDelete, 1);
      // }
    },
    getRow(row) {
      console.log(row);
      this.getRowData = row;

      (this.device.deviceid = `${row.deviceid}`),
        (this.device.devicename = `${row.devicename}`),
        (this.device.devicetype = `${row.devicetype}`),
        (this.device.devicetoken = `${row.devicetoken}`),
        (this.device.lat = `${row.lat}`),
        (this.device.lon = `${row.lon}`),
        (this.device.commdate = `${row.commdate}`),
        (this.device.warranty = `${row.warranty}`);
    },
  },
  computed: {
    queriedData() {
      let result = this.devices;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.devices.length;
    },
    bigLineChartCategories() {
      return [
        { name: "Accounts", icon: "tim-icons icon-single-02" },
        { name: "Purchases", icon: "tim-icons icon-gift-2" },
        { name: "Sessions", icon: "tim-icons icon-tap-02" },
      ];
    },
  },

  mounted() {
    this.getDeviceList();
    // Fuse search initialization.
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.devices;
      this.fuseSearch = new Fuse(this.devices, {
        keys: ["devicename", "devicetype"],
        threshold: 1.0,
      });
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.head h3 {
  display: inline;
  padding-bottom: 10px;
}
.brightness p {
  display: inline;
}
.bright slider {
  display: inline;
}
.chartButton {
  text-align: right;
}
#fileName {
  margin: 3%;
  color: black;
  font-weight: bold;
}
</style>
